export default __webpack_public_path__ + "static/media/math-single-select.844bf480.svg";